/** @file GL blendFuncSeparate factors per Blend (spec §7.3): [srcRGB, dstRGB, srcAlpha, dstAlpha]. */

/**
 * Index = Blend (0 normal, 1 additive, 2 multiply, 3 screen). Values are the WebGL enums ONE (1),
 * ONE_MINUS_SRC_COLOR (0x0301), ONE_MINUS_SRC_ALPHA (0x0303) and DST_COLOR (0x0306). Multiply and screen take
 * normal's alpha (as raster's blendPixel); additive alpha min(1, Sa + Da) is the RGBA8 clamp of ONE, ONE.
 */
export const BLEND_FACTORS = [
  [1, 0x0303, 1, 0x0303],
  [1, 1, 1, 1],
  [0x0306, 0x0303, 1, 0x0303],
  [1, 0x0301, 1, 0x0303],
] as const;
